// extracted by mini-css-extract-plugin
export var fadeIn = "_8t-0";
export var panelInner = "_8t-2";
export var panelOuter = "_8t-1";